import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creditNotes: [],
};

const creditNotesSlice = createSlice({
  name: "creditNotes",
  initialState,
  reducers: {
    setCreditNotes(state, action) {
      state.creditNotes = action.payload;
    },
    addCreditNote(state, action) {
      const newCreditNote = action.payload;
      return {
        ...state,
        creditNotes: [...state.creditNotes, newCreditNote],
      };
    },
  },
});

export function issueCreditNote({ data }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/credit-notes`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(creditNotesSlice.actions.addCreditNote(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default creditNotesSlice.reducer;
